<header>
  <img
    src="logo_te.svg"
    width="60"
    title="TotalEnergies"
    alt="TotalEnergies"
    class="logo me-4 pointer"
    routerLink="/home"
  />
  <div class="header-right">
    <div class="header-top">
      <div class="me-auto header-title">
        <div class="app-name me-3">
          {{ 'general.app_name' | translate }}
        </div>
        @if (!isEnvProd) {
          <div class="env-badge" [ngClass]="envName">{{ envName }} env</div>
        }
      </div>
      @if (user()) {
        <ng-container class="header-badge-container">
          <div class="header-badge user-badge" [matMenuTriggerFor]="userMenu">
            <span class="display-name">{{ getUserDisplayName() }}</span>
            <mat-icon color="primary" class="mb-1" svgIcon="total-user"></mat-icon>
          </div>

          <mat-menu
            #userMenu="matMenu"
            [overlapTrigger]="false"
            role="menu"
            attr.aria-label="{{ 'header.aria.menu_user' | translate }}"
          >
            @if (user()?.role) {
              <div class="username menu-item role">
                <mat-icon class="me-2">badge</mat-icon>
                {{ 'entities.roles.' + user()?.role?.code!.toLowerCase() | translate }}
              </div>
            }
            <button mat-menu-item routerLink="/auth/logout">{{ 'general.main_menu.logout' | translate }}</button>
          </mat-menu>
        </ng-container>
      }
    </div>

    <div
      class="d-flex"
      [class.justify-content-end]="!userService.isLoggedIn()"
      [class.justify-content-between]="userService.isLoggedIn()"
    >
      @if (userService.isLoggedIn()) {
        <mps-app-navigation></mps-app-navigation>
      }
    </div>

    <div (click)="nav?.toggle()" role="navigation" (keyup)="nav?.toggle()" class="burger-container" role="menu">
      <mat-icon class="burger menu" [ngClass]="{ active: !nav?.opened }">menu</mat-icon>
      <mat-icon class="burger close" [ngClass]="{ active: nav?.opened }">close</mat-icon>
    </div>
  </div>
</header>
